// 2026-10-25：顶部菜单跟随计算器语言(en/zh 繁体)。链接取自 ebaoguo.com 对应语言的主菜单；简体沿用 LogoHeader.vue 原列表。
const l = (name, path, children = []) => ({ name, path, children })
const W = 'https://ebaoguo.com'

export const enNav = [
  l('Home', `${W}/en/`),
  l('Help', 'Help', [
    l('Getting Started', `${W}/en/getting-started/`),
    l('FAQ', `${W}/en/faq/`),
    l('Store Locator (Australia)', `${W}/en/store-locator/`),
    l('Warehouse Locations', `${W}/en/ebaoguo-warehouse-location/`),
    l('Prohibited & Restricted Items', `${W}/en/prohibited-and-restricted-items/`),
  ]),
  l('Start Forwarding', 'Start Forwarding', [
    l('Extra Services & Fees', `${W}/en/ebaoguo-extra-services/`),
    l('From Australia', 'From Australia', [
      l('Australia to Malaysia', `${W}/en/kb/shipping-from-australia-to-malaysia/`),
      l('Australia to Hong Kong', `${W}/en/kb/shipping-from-australia-to-hongkong/`),
      l('Australia to New Zealand', `${W}/en/kb/shipping-from-australia-to-new-zealand/`),
      l('Australia to Taiwan', `${W}/en/kb/shipping-from-australia-to-taiwan/`),
      l('Australia to Singapore', `${W}/en/kb/shipping-from-australia-to-singapore/`),
      l('Australia to UK', `${W}/en/kb/shipping-from-australia-to-uk/`),
      l('Interstate Delivery', 'https://pickup.ebaoguo.com'),
    ]),
    l('From China', 'From China', [
      l('China to Australia by Sea', `${W}/en/kb/shipping-from-china-to-australia-by-sea/`),
      l('China to Australia by Air', `${W}/en/kb/shipping-from-china-to-australia-by-air/`),
      l('China to New Zealand', `${W}/en/kb/shipping-from-china-to-new-zealand/`),
      l('China Post EMS', `${W}/en/kb/china-post-ems/`),
      l('China to Malaysia', `${W}/en/kb/shipping-from-china-to-malaysia/`),
      l('Mainland China to Hong Kong', `${W}/en/kb/shipping-from-china-mainland-to-hong-kong/`),
      l('China to Singapore', `${W}/en/kb/ship-from-china-to-singapore/`),
    ]),
    l('From Malaysia', 'From Malaysia', [
      l('Malaysia to Australia', `${W}/en/kb/ship-from-malaysia-to-australia/`),
      l('Malaysia to Taiwan', `${W}/en/kb/ship-from-malaysia-to-taiwan/`),
      l('Malaysia to China', `${W}/en/kb/shipping-from-malaysia-to-china/`),
      l('Malaysia to New Zealand', `${W}/en/kb/shipping-from-malaysia-to-new-zealand/`),
      l('Malaysia to Thailand', `${W}/en/kb/shipping-from-malaysia-to-thailand/`),
    ]),
    l('From Japan', 'From Japan', [
      l('Japan Consolidation Guide', `${W}/en/kb/shopping-on-jp/`),
      l('Japan to Malaysia', `${W}/en/kb/shipping-from-japan-to-malaysia/`),
      l('Japan to Taiwan', `${W}/en/kb/shipping-from-japan-to-taiwan/`),
      l('Japan to Australia', `${W}/en/kb/shipping-from-japan-to-australia/`),
      l('Japan Post EMS', `${W}/en/kb/japan_post_ems/`),
      l('Japan to Singapore', `${W}/en/kb/shipping-from-japan-to-singapore/`),
      l('Japan to China', `${W}/en/kb/shipping-from-janpan-to-china/`),
      l('Japan to New Zealand', `${W}/en/kb/shipping-from-japan-to-new-zealand/`),
    ]),
    l('From the U.S.', 'From the U.S.', [
      l('USA to Malaysia', `${W}/en/kb/shipping-from-usa-to-malaysia/`),
    ]),
    l('From Taiwan', 'From Taiwan', [
      l('Taiwan to Singapore', `${W}/en/kb/shipping-from-taiwan-to-singapore/`),
      l('Taiwan to Malaysia', `${W}/en/kb/shipping-from-taiwan-to-malaysia/`),
    ]),
  ]),
  l('Shipping Calculator', 'https://cal.ebaoguo.com/'),
  l('Share', 'Share', [
    l('Selected Stores', `${W}/en/selected-stores/`),
    l('Shop Australian Products', 'https://zayu.com.au/'),
  ]),
  l('My Account', 'https://dashboard.ebaoguo.com/'),
]

export const zhNav = [
  l('首頁', `${W}/zh-hant/`),
  l('幫助中心', '幫助中心', [
    l('如何開始', `${W}/zh-hant/getting-started/`),
    l('常見問題', `${W}/zh-hant/faq/`),
    l('代收點查詢(澳洲)', `${W}/zh-hant/store-locator/`),
    l('易包裹倉庫分布', `${W}/zh-hant/ebaoguo-warehouse-location/`),
    l('禁運品及限制產品', `${W}/zh-hant/prohibited-and-restricted-items/`),
  ]),
  l('開始轉運', '開始轉運', [
    l('額外服務收費標準', `${W}/zh-hant/ebaoguo-extra-services/`),
    l('從澳洲發貨', '從澳洲發貨', [
      l('澳洲寄馬來西亞', `${W}/zh-hant/kb/shipping-from-australia-to-malaysia/`),
      l('澳洲寄香港', `${W}/zh-hant/kb/shipping-from-australia-to-hongkong/`),
      l('澳洲寄紐西蘭', `${W}/zh-hant/kb/sending-from-australia-to-new-zealand/`),
      l('澳洲寄台灣', `${W}/zh-hant/kb/shipping-from-australia-to-taiwan/`),
      l('澳洲寄新加坡', `${W}/zh-hant/kb/shipping-from-australia-to-singapore/`),
      l('澳洲寄回中國', `${W}/zh-hant/kb/shipping-from-australia-to-china/`),
      l('澳洲寄英國', `${W}/zh-hant/kb/shipping-from-australia-to-uk/`),
      l('澳洲境內轉運', 'https://pickup.ebaoguo.com'),
    ]),
    l('從中國發貨', '從中國發貨', [
      l('中國海運到澳洲', `${W}/zh-hant/kb/shipping-from-china-to-australia-by-sea/`),
      l('中國空運到澳洲', `${W}/zh-hant/kb/shipping-from-china-to-australia-by-air/`),
      l('中國郵寄紐西蘭', `${W}/zh-hant/kb/shipping-from-china-to-new-zealand/`),
      l('中國郵政EMS線路', `${W}/zh-hant/kb/china-post-ems/`),
      l('中國郵寄馬來西亞', `${W}/zh-hant/kb/shipping-from-china-to-malaysia/`),
      l('中國大陸郵寄台灣', `${W}/zh-hant/kb/china-mainland-to-taiwan/`),
      l('中國大陸郵寄香港', `${W}/zh-hant/kb/shipping-from-china-mainland-to-hong-kong/`),
      l('淘寶集運到新加坡', `${W}/zh-hant/kb/shipping-from-china-to-singapore/`),
    ]),
    l('從馬來西亞發貨', '從馬來西亞發貨', [
      l('馬來西亞寄澳洲', `${W}/zh-hant/kb/ship-from-malaysia-to-australia/`),
      l('馬來西亞集運台灣', `${W}/zh-hant/kb/shipping-from-malaysia-to-taiwan/`),
      l('馬來西亞郵寄新加坡', `${W}/zh-hant/kb/shipping-from-malaysia-to-singapore/`),
      l('馬來西亞郵寄中國', `${W}/zh-hant/kb/shipping-from-malaysia-to-china/`),
      l('馬來西亞郵寄紐西蘭', `${W}/zh-hant/kb/shipping-from-malaysia-to-new-zealand/`),
      l('馬來西亞寄泰國', `${W}/zh-hant/kb/shipping-from-malaysia-to-thailand/`),
    ]),
    l('從日本發貨', '從日本發貨', [
      l('日本集運教學', `${W}/zh-hant/kb/shopping-on-jp/`),
      l('日本寄馬來西亞', `${W}/zh-hant/kb/shipping-from-japan-to-malaysia/`),
      l('日本寄台灣', `${W}/zh-hant/kb/shipping-from-japan-to-taiwan/`),
      l('日本郵寄澳洲', `${W}/zh-hant/kb/shipping-from-japan-to-australia/`),
      l('日本郵政郵寄全世界', `${W}/zh-hant/kb/japan_post_ems/`),
      l('日本寄新加坡', `${W}/zh-hant/kb/shipping-from-japan-to-singapore/`),
      l('日本郵寄中國', `${W}/zh-hant/kb/shipping-from-janpan-to-china/`),
      l('日本寄紐西蘭', `${W}/zh-hant/kb/shipping-from-japan-to-new-zealand-by-air/`),
    ]),
    l('從美國發貨', '從美國發貨', [
      l('美國郵寄馬來西亞', `${W}/zh-hant/kb/shipping-from-usa-to-malaysia/`),
    ]),
    l('從台灣發貨', '從台灣發貨', [
      l('台灣郵寄新加坡', `${W}/zh-hant/kb/shipping-from-taiwan-to-singapore/`),
      l('台灣郵寄澳洲', `${W}/zh-hant/kb/shipping-from-taiwan-to-australia/`),
      l('台灣寄馬來西亞', `${W}/zh-hant/kb/shipping-from-taiwan-to-malaysia/`),
    ]),
    l('從香港發貨', '從香港發貨', [
      l('香港寄馬來西亞', `${W}/zh-hant/kb/shipping-from-hongkong-to-malaysia/`),
      l('香港郵寄台灣', `${W}/zh-hant/kb/shipping-from-hongkong-to-taiwan/`),
      l('香港郵政郵寄全世界', `${W}/zh-hant/kb/hongkong_post_ems/`),
    ]),
  ]),
  l('運費計算', 'https://cal.ebaoguo.com/'),
  l('分享', '分享', [
    l('購物網站推薦', `${W}/zh-hant/selected-stores/`),
    l('澳洲直郵', 'https://zayu.com.au/'),
  ]),
  l('我的帳戶', 'https://dashboard.ebaoguo.com/'),
]
